export default __webpack_public_path__ + "static/media/home.91a2bf24.png";